<idp-simple-modal
  [id]="'passenger-info-modal'"
  class="fr-health-landing fr-font-medium"
  [modalStyle]="buttonStyle"
  idpAppModalfocus
  [open]="modalOpen"
  [modalTitle]="modalTitle"
  [showCloseButton]="showCloseBtn"
  [showCloseIcon]="showCloseIcon"
  [cancelButtonTitle]="cancelBtnTitle"
  [whiteCloseIcon]="whiteCloseIcon"
  [showSubmitButton]="showSubmitBtn"
  [scrollModal]="true"
  [closeOnEscape]="false"
  [submitButtonTitle]="submitBtnTitle"
  [showFooter]="showFooter"
  [showContinue]="showContinueBtn"
  [preventCloseModal]="closePopupModal"
  [closeOnBackgroundClick]="false"
  [width]="width"
  [height]="height"
  [headerStyle]="headerStyle"
  (openChange)="closeModal()"
  (ctaAction)="onCancel()"
  (continueAction)="onSaveModal()"
  (previousTab)="onPreviousTab($event)"
>
  <div tabindex="-1" class="mt-modal--scroll">
    <div
      class="mt-modal--container"
      [ngClass]="{
        'mt-modal--side-top-padding': sideTopPaddingEnabled === true
      }"
    >
      <ng-content></ng-content>
    </div>
  </div>
</idp-simple-modal>
